var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContributionsPiggyBank = function SvgContributionsPiggyBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.125 6.417H7.899C6.917 4.743 5.26 4.483 4.453 4.593l-1.045.149.943 3.235a6.85 6.85 0 00-1.718 2.106H0V16.5h2.627a6.844 6.844 0 005.623 3.636V22h1.833v-1.833h3.667V22h1.833v-1.856C19.16 19.906 22 16.928 22 13.292a6.882 6.882 0 00-6.875-6.875zm.458 5.5H9.167v-1.834h6.416v1.834z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.375,
    cy: 2.292,
    r: 2.292
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContributionsPiggyBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contributions -piggy-bank.559baf05a518cc3c5a9faf799c0af0e5.svg";